import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import { store } from "./store/store";
import { BrowserRouter } from "react-router-dom";
import { errorLogService } from "./services/errorLogService";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Capturar errores globales no manejados
window.addEventListener("error", (event) => {
  errorLogService.logError(event.error || new Error(event.message), {
    component: "global",
    file: event.filename,
    line: event.lineno,
    column: event.colno,
    type: "windowError",
  });
});

// Capturar promesas rechazadas no manejadas
window.addEventListener("unhandledrejection", (event) => {
  const error = event.reason instanceof Error 
    ? event.reason 
    : new Error(String(event.reason));
  
  errorLogService.logError(error, {
    component: "promise",
    type: "unhandledRejection",
  });
});

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

reportWebVitals();
